export const getWholeRow = (params) => {
    return params.row;
}